export enum RMAType {
  Tyres = 'S1TyreRetour',
  Batteries = 'S1BatteryRetour',
  AxNLTyre = 'AxNl_TyreService',
  AxNLBattery = 'AxNl_BatteryService',
  Default = 'RMA'
}
